
import CommonUtils from "@/common-utils";
import Constants from "@/constants";
import { MainNotificationsVO } from "@/vo/common.vo";
import axios from "axios";
import { Component, Vue } from "vue-property-decorator";
import { MypageOVO } from "./vo/mypage.vo";
import channelIO from "@/assets/js/channel-io";

// 글로벌에서만 채팅 사용함
let channel;
if (CommonUtils.isSystemLocale("global") == true) {
  channel = new channelIO();
}

@Component
export default class Mypage extends Vue {
  //data
  mypageOVO: MypageOVO = {} as MypageOVO;
  orderStatusCountObject = {
    cd00401: 0,
    cd00402: 0,
    cd00403: 0,
    cd00404: 0,
    // 00409 코드는 원래 없으나 취소/반품(각각 00406/00407)은 그룹핑되어 카운팅되어야 해서 00409라는 임시코드로 변경함
    cd00409: 0,
  };

  hasNewNotification = false; // 새알림있음?

    noticePop = false; // 리뷰포인트 팝업 

  /**
   * 내가 본 상품 수
   */
  get recentProductCnt(): number {
    const recentProduct = CommonUtils.getLocalStorageObject(Constants.RECENT_PRODUCTS);
    if (recentProduct instanceof Array) {
      return recentProduct.length;
    } else {
      return 0;
    }
  }

  // 뱃지 숫자
  getBadgeNumber(statusCd: string) {
    return this.orderStatusCountObject[statusCd] > 99 ? "99+" : this.orderStatusCountObject[statusCd];
  }

  isBadgeNumber(statusCd: string) {
    return this.orderStatusCountObject[statusCd] ? true : false;
  }

  // TODO 뭔소린지 주석 달아라
  setGroupingByStatusCnt() {
    this.mypageOVO.orderStatusList.forEach((row) => {
      this.orderStatusCountObject[`cd${row.orderStatusCd}`] += row.totCnt;
    });
  }

  activated() {
    // 알림 있음?
    this.$store.dispatch("updateNotification");
  }

  // 포인트 타입코드로 포인트 정책 조회
  getPointPolicyByPointTypeCd(pointTypeCd: string, boardTypeCd: string) {
    const policy = this.mypageOVO.ugcPointPolicys.filter(v=> v.pointTypeCd == pointTypeCd && v.boardTypeCd == boardTypeCd);

    if(!policy.length) {
      return '';
    }
    return policy[0].pointVal;
  }

  //initialized events
  created(): void {
    // 회원정보 조회
    axios.get("/mypage").then((r) => {
      this.mypageOVO = r.data;
      this.setGroupingByStatusCnt();

      // 회원정보 가져온 담에 초기화해야댐
      // 채팅문의 글로벌만 허용
      if (channel) {
        let language = process.env.VUE_APP_I18N_LOCALE || "en";

        // en, ko, ja 만 가능
        const allowLanguages = ["en", "ko", "ja"];

        if (allowLanguages.includes(language) == false) {
          language = "en";
        }

        const settings = {
          pluginKey: process.env.VUE_APP_CHANNEL_IO_PLUGIN_KEY,
          customLauncherSelector: ".one-inquiry2",
          hideChannelButtonOnBoot: true,
          language: language,
          hidePopup: true,
        };

        // 로그인했다면
        if (this.mypageOVO.member) {
          Object.assign(settings, {
            memberId: this.mypageOVO.member.memCd,
            profile: {
              name: this.mypageOVO.member.memNm,
              mobileNumber: this.mypageOVO.member.memPh,
              email: this.mypageOVO.member.memEmail,
              avatarUrl: this.mypageOVO.member.memProfileFileUrl,
            },
          });
        }

        channel.boot(settings);
      }
    });
    //로컬스토리지  orderCd 제거
    if (CommonUtils.getLocalStorageObject(Constants.ORDER_PAYMENT_CD)) {
      CommonUtils.removeLocalStorageObject(Constants.ORDER_PAYMENT_CD);
    }
    // 알림 있음?
    this.$store.dispatch("updateNotification");
  }
}
